import { render, staticRenderFns } from "./fast-tracking.vue?vue&type=template&id=641c0f6b&"
import script from "./fast-tracking.vue?vue&type=script&lang=js&"
export * from "./fast-tracking.vue?vue&type=script&lang=js&"
import style0 from "./fast-tracking.vue?vue&type=style&index=0&id=641c0f6b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports